import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../Services/Services.css";
import CharIcon from "../../Assets/img/word.png";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import API from "../Service/Baseservice";
import { useParams } from "react-router-dom";
import Loading from "../../Loading/loading";
import OurStoryPreview from "./OurStoryPreview";
const aboutMap = {
    1: 3,
    2: 8
};

const OurstoryEdit = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const lang = Number(queryParams.get("lang")) || 1;
    const languageId = Number(queryParams.get("lang")) || 1;
    const [loading, setLoading] = useState(true);
    const [showPreviewOurStory, setShowPreviewOurStory] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "", // success | error | info
    });
    const [formData, setFormData] = useState({
        ourstory_id: "",
        language_id: languageId,
        about_id: aboutMap[languageId],
        heading: "",
        title: "",
        description: "",
        active: 1,
        updatedBy: 1,
        sectionsData: [
            { section_id: 1, heading: "", description: "" },
            { section_id: 2, heading: "", description: "" },
            { section_id: 3, heading: "", description: "" }
        ]
    });

    const getPlainTextLength = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return (div.textContent || div.innerText || "").length;
    };

    useEffect(() => {
        if (!id || !languageId) return;

        setLoading(true);

        API.post("list_ourstory/condition", {
            language_id: languageId,
            about_id: Number(id),
        })
            .then((res) => {
                const story = res.data?.data?.data?.[0];
                if (!story) return;

                setFormData({
                    ourstory_id: story.ourstory_id,
                    language_id: story.language_id,
                    about_id: Number(id),
                    heading: story.heading || "",
                    title: story.title || "",
                    description: story.description || "",
                    active: story.active || 1,
                    updatedBy: 1,
                    sectionsData: story.sections || [],
                });
            })
            .finally(() => setLoading(false));
    }, [id, languageId]);




    const handleChange = (e) =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSectionChange = (index, field, value) => {
        const updated = [...formData.sectionsData];
        updated[index][field] = value;
        setFormData({ ...formData, sectionsData: updated });
    };

    const handleUpdate = () => {

        if (!formData.heading.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Heading is required!",
                type: "info",
            });
        }

        if (!formData.title.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Title is required!",
                type: "info",
            });
        }

        if (!formData.description.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Description is required!",
                type: "info",
            });
        }

        for (let sec of formData.sectionsData) {
            if (!sec.heading.trim() || !sec.description.trim()) {
                return setPopup({
                    show: true,
                    title: "Required",
                    message: "All card fields are required!",
                    type: "info",
                });
            }
        }

        setLoading(true);

        API.post("ourstory_edit/update", formData)
            .then(() => {
                setPopup({
                    show: true,
                    title: "Success",
                    message: "Story updated successfully!",
                    type: "success",
                });

                setTimeout(() => navigate("/aboutus"), 1300);
            })
            .catch(() =>
                setPopup({
                    show: true,
                    title: "Error",
                    message: "Failed to update story!",
                    type: "error",
                })
            )
            .finally(() => setLoading(false));
    };

    const handlePreview = () => {

        // BASIC VALIDATION
        if (!formData.heading.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Heading is required for preview!",
                type: "info",
            });
        }

        if (!formData.title.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Title is required for preview!",
                type: "info",
            });
        }

        if (!formData.description.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Description is required for preview!",
                type: "info",
            });
        }

        // SECTIONS VALIDATION
        for (let sec of formData.sectionsData) {
            if (!sec.heading.trim() || !sec.description.trim()) {
                return setPopup({
                    show: true,
                    title: "Required",
                    message: "All 3 card title and description fields are required!",
                    type: "info",
                });
            }
        }

        // SET PREVIEW DATA
        setPreviewData({
            heading: formData.heading,
            title: formData.title,
            description: formData.description,
            sectionsData: formData.sectionsData,
        });

        setShowPreviewOurStory(true);
    };

    const MAX_CHARS = 4000;

    const [lastValidContent, setLastValidContent] = useState({
        main: "",
        0: "",
        1: "",
        2: ""
    });


    const handleCkEditorChange = (html, sectionIndex = null, editor) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        const text = div.textContent || "";

        const key = sectionIndex === null ? "main" : sectionIndex;

        if (text.length <= MAX_CHARS) {
            // ✅ Save valid content
            setLastValidContent(prev => ({
                ...prev,
                [key]: html
            }));

            if (sectionIndex === null) {
                setFormData(prev => ({
                    ...prev,
                    description: html
                }));
            } else {
                setFormData(prev => {
                    const updated = [...prev.sectionsData];
                    updated[sectionIndex].description = html;
                    return { ...prev, sectionsData: updated };
                });
            }
        } else {
            // ❌ Restore last valid content (blocks typing, allows backspace)
            editor.setData(lastValidContent[key] || "");
        }
    };



    return (
        <div className="ourstory-containeradd">
            <div className="service-header-bar">
                <h2 className="services-title1">Edit Our Story</h2>

                <div className="button-group">
                    {/* LANGUAGE SWITCH */}
                    <div className="filter-block">
                        <label>Language</label>
                        <div className="input-container">
                            <select
                                className="input-field"
                                value={languageId}
                                onChange={(e) => {
                                    const newLang = Number(e.target.value);
                                    const newId = aboutMap[newLang];

                                    navigate(`/ourstoryedit/${newId}?lang=${newLang}`, {
                                        replace: true,
                                    });
                                }}
                            >
                                <option value={1}>English</option>
                                <option value={2}>Français</option>
                            </select>
                        </div>
                    </div>
                    <button onClick={handlePreview} className="language-save-btn">
                        Preview
                    </button>
                    <button className="language-save-btn" onClick={handleUpdate}>
                        Save
                    </button>

                    <button className="cancel-btn " style={{ marginTop: "24px" }} onClick={() => navigate("/aboutus")}>
                        Back
                    </button>
                </div>
            </div>
            {loading ? (
                <Loading />
            ) : (
                <>
                    <div className="ourstoryedit-container">

                        {/* MAIN HEADING */}
                        <div className="form-group ourstory-full-width">
                            <label>Heading <span className="required">*</span></label>
                            <input
                                type="text"
                                name="heading"
                                value={formData.heading}
                                // maxLength={70}
                                onChange={handleChange}
                            />
                        </div>

                        {/* LEFT SIDE */}
                        <div className="ourstory-left-form">
                            <div className="form-group">
                                <label>Title <span className="required">*</span></label>
                                <input
                                    type="text"
                                    name="title"
                                    // maxLength={150}
                                    value={formData.title}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Description */}
                            <div className="news-form-group editor-small">
                                <label className="news-description-label">
                                    <span className="label-text">Description <span className="required">*</span></span>
                                    <div className="char-wrapper">
                                        <img src={CharIcon} alt="Character count" />
                                        <span className="char-count">
                                            {getPlainTextLength(formData.description)}/4000
                                        </span>
                                    </div>
                                </label>

                                <CKEditor
                                    editor={ClassicEditor}
                                    data={formData.description}
                                    onReady={(editor) =>
                                        setLastValidContent(prev => ({
                                            ...prev,
                                            main: editor.getData()
                                        }))
                                    }
                                    onChange={(event, editor) =>
                                        handleCkEditorChange(editor.getData(), null, editor)
                                    }
                                />



                            </div>

                            {/* SECTION 2 */}
                            <div className="form-group">
                                <label>Card Two <span className="required">*</span></label>
                                <input
                                    type="text"
                                    value={formData.sectionsData[1].heading}
                                    // maxLength={150}
                                    onChange={(e) =>
                                        handleSectionChange(1, "heading", e.target.value)
                                    }
                                />
                            </div>

                            <div className="news-form-group editor-small">
                                <label className="news-description-label">
                                    <span className="label-text">
                                        Description <span className="required">*</span>
                                    </span>
                                    <div className="char-wrapper">
                                        <img src={CharIcon} alt="Character count" />
                                        <span className="char-count">
                                            {getPlainTextLength(formData.sectionsData[1].description)}/4000
                                        </span>
                                    </div>
                                </label>

                                <CKEditor
                                    editor={ClassicEditor}
                                    data={formData.sectionsData[1].description}
                                    onReady={(editor) =>
                                        setLastValidContent(prev => ({
                                            ...prev,
                                            0: editor.getData()
                                        }))
                                    }
                                    onChange={(event, editor) =>
                                        handleCkEditorChange(editor.getData(), 1, editor)
                                    }
                                />



                            </div>
                        </div>

                        {/* RIGHT SIDE */}
                        <div className="ourstory-right-section">
                            {/* SECTION 1 */}
                            <div className="form-group">
                                <label>Card One <span className="required">*</span></label>
                                <input
                                    type="text"
                                    value={formData.sectionsData[0].heading}
                                    // maxLength={150}
                                    onChange={(e) =>
                                        handleSectionChange(0, "heading", e.target.value)
                                    }
                                />
                            </div>

                            <div className="news-form-group editor-small">
                                <label className="news-description-label">
                                    <span className="label-text">Description <span className="required">*</span></span>
                                    <div className="char-wrapper">
                                        <img src={CharIcon} alt="Character count" />
                                        <span className="char-count">
                                            {getPlainTextLength(formData.sectionsData[0].description)}/4000
                                        </span>
                                    </div>
                                </label>

                                <CKEditor
                                    editor={ClassicEditor}
                                    data={formData.sectionsData[0].description}
                                    onReady={(editor) =>
                                        setLastValidContent(prev => ({
                                            ...prev,
                                            0: editor.getData()
                                        }))
                                    }
                                    onChange={(event, editor) =>
                                        handleCkEditorChange(editor.getData(), 0, editor)
                                    }
                                />



                            </div>

                            {/* SECTION 3 */}
                            <div className="form-group">
                                <label>Card Three <span className="required">*</span></label>
                                <input
                                    type="text"
                                    value={formData.sectionsData[2].heading}
                                    // maxLength={150}
                                    onChange={(e) =>
                                        handleSectionChange(2, "heading", e.target.value)
                                    }
                                />
                            </div>

                            <div className="news-form-group editor-small">
                                <label className="news-description-label">
                                    <span className="label-text">Description <span className="required">*</span></span>
                                    <div className="char-wrapper">
                                        <img src={CharIcon} alt="Character count" />
                                        <span className="char-count">
                                            {getPlainTextLength(formData.sectionsData[2].description)}/4000
                                        </span>
                                    </div>
                                </label>

                                <CKEditor
                                    editor={ClassicEditor}
                                    data={formData.sectionsData[2].description}
                                    onReady={(editor) =>
                                        setLastValidContent(prev => ({
                                            ...prev,
                                            0: editor.getData()
                                        }))
                                    }
                                    onChange={(event, editor) =>
                                        handleCkEditorChange(editor.getData(), 2, editor)
                                    }
                                />



                            </div>

                        </div>
                    </div>
                </>
            )}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <button className="btn ok-btn" onClick={() => setPopup({ ...popup, show: false })}>
                            OK
                        </button>
                    </div>
                </div>
            )}
            {showPreviewOurStory && (
                <OurStoryPreview
                    previewService={previewData}
                    setShowPreviewOurStory={setShowPreviewOurStory}
                />
            )}
        </div>
    );
};

export default OurstoryEdit;
